import { FC } from 'react';
import styled, { CSSObject } from 'styled-components';

import { EColor, WithThemeProps } from '@core/type';
import { getPaletteHandlers, getPaperLeftyBorderedColorProps } from '@core/util';

import { Paper } from './Paper';
import { PaperLeftyBorderedProps } from './interface-paper';

export const PaperLeftyBordered = ({ children, ...restPaperProps }: PaperLeftyBorderedProps) => {
  return <StyledPaper {...restPaperProps}>{children}</StyledPaper>;
};

const StyledPaper: FC<PaperLeftyBorderedProps> = styled(Paper)(({
  theme: { palette },
  colorType,
  isOutlined,
  hideBorder,
}: Partial<PaperLeftyBorderedProps> & WithThemeProps) => {
  const { getColor } = getPaletteHandlers(palette);
  const colorProps = getPaperLeftyBorderedColorProps({ palette, color: colorType });
  const borderColor =
    isOutlined &&
    getColor({
      semanticType: EColor.NEUTRAL,
      variant: EColor.LIGHT,
    });

  return {
    position: 'relative',
    borderColor,
    borderLeftColorLeft: getColor(EColor.TRANSPARENT),
    borderWidth: isOutlined ? '1px 1px 1px 8px' : '0 0 0 8px',
    ...(!hideBorder && {
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '-8px',
        width: '8px',
        borderRadius: '8px 0 0 8px',
        ...colorProps,
      },
    }),
  } as CSSObject;
});
